/**
 * Botón de acción de fila (HU-012) — ícono en vez de texto ("Editar"/
 * "Eliminar"), reusado por las 4 pantallas de gestión (Usuarios, Roles,
 * Vías, Categorías) para que todas se vean igual. `variante` decide el
 * color (`editar` neutro, `eliminar` rojo) — `titulo` es el `title`/
 * `aria-label`, ya que sin texto visible el ícono solo no alcanza para
 * lectores de pantalla.
 */
const BotonAccionIcono = ({ icono, variante = 'editar', titulo, onClick, disabled }) => (
  <button
    type="button"
    className={`panel-icono-boton panel-icono-boton-${variante}`}
    onClick={onClick}
    disabled={disabled}
    title={titulo}
    aria-label={titulo}
  >
    <i className={`fas ${icono}`}></i>
  </button>
);

export default BotonAccionIcono;
